import styled from "styled-components";
import { setFontVariant } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";
import { CenteredFlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const Container = styled(CenteredFlexColumn)`
    text-align: center;
    gap: 20px;
`;

export const TextContainer = styled(CenteredFlexColumn)`
    white-space: pre-line;
    gap: 8px;
`;

export const Title = styled.div`
    ${setFontVariant("subsectionTitle", colorsPalettes.carbon[500])};
`;

export const Subtitle = styled.div`
    ${setFontVariant("sectionTitle", colorsPalettes.carbon[400])};
`;

export const ButtonsContainer = styled(CenteredFlexColumn)``;
